import script from "./ChatContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatContent.vue?vue&type=script&setup=true&lang=ts"

import "./ChatContent.vue?vue&type=style&index=0&id=75d66c83&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d66c83"]])

export default __exports__